var map = {
	"./calendar.svg": 33734,
	"./clock.svg": 99794,
	"./close-button.svg": 80092,
	"./drag.svg": 48478,
	"./edit.svg": 19855,
	"./search.svg": 41868,
	"./trash.svg": 7079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92498;